import { Link } from 'react-router-dom'
// web/src/features/admin/CommunitiesAdminDev.jsx
import React from 'react'
import AdminBar from '../../components/AdminBar.jsx'
import './communities-admin.css'

// Direct Firestore access
import { app as firebaseApp } from '@/firebase'
import {
  getFirestore,
  collection,
  getDocs,
  doc,
  updateDoc,
  addDoc,
} from 'firebase/firestore'

const complianceSetupEnabled = (import.meta.env.DEV && import.meta.env.VITE_COMPLIANCE_LOCAL === 'true') || import.meta.env.VITE_COMPLIANCE_ENABLED === 'true'

export default function CommunitiesAdminDev() {
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState('')
  const [rows, setRows] = React.useState([])        // raw from Firestore
  const [q, setQ] = React.useState('')              // search box
  const [onlyActive, setOnlyActive] = React.useState(true) // active filter

  // create form
  const [creating, setCreating] = React.useState(false)
  const [newCode, setNewCode] = React.useState('')
  const [newName, setNewName] = React.useState('')
  const [newEntrata, setNewEntrata] = React.useState('')
  const [newPhiladelphia, setNewPhiladelphia] = React.useState('')
  const [newActive, setNewActive] = React.useState(true)
  const [creatingBusy, setCreatingBusy] = React.useState(false)

  // edit row
  const [editingId, setEditingId] = React.useState('')
  const [editName, setEditName] = React.useState('')
  const [editEntrata, setEditEntrata] = React.useState('')
  const [editPhiladelphia, setEditPhiladelphia] = React.useState('')
  const [editActive, setEditActive] = React.useState(true)
  const [savingEdit, setSavingEdit] = React.useState(false)

  const db = React.useMemo(() => getFirestore(firebaseApp), [])

  async function load() {
    setError('')
    setLoading(true)
    try {
      const snap = await getDocs(collection(db, 'communities'))
      const data = snap.docs.map(d => ({ id: d.id, ...d.data() }))
      setRows(data)
      console.log('[Communities] loaded', data.length)
    } catch (e) {
      console.error('[Communities] load failed:', e)
      setError(e?.message || 'Failed to load communities.')
    } finally {
      setLoading(false)
    }
  }

  React.useEffect(() => { load() }, [])

  const showEntrata = v => (v == null || v === '' ? '—' : String(v))

  async function setActive(row, next) {
    try {
      await updateDoc(doc(db, 'communities', row.id), { isActive: next })
      setRows(prev => prev.map(r => (r.id === row.id ? { ...r, isActive: next } : r)))
    } catch (e) {
      console.error('setActive failed', e)
      alert(e?.message || 'Failed to update community')
    }
  }

  function beginEdit(row) {
    setEditingId(row.id)
    setEditName(row.communityName || '')
    setEditEntrata(row.entrataCommunityId != null ? String(row.entrataCommunityId) : '')
    setEditActive(!!row.isActive)
    setEditPhiladelphia(row.isCityOfPhiladelphia === true ? 'yes' : row.isCityOfPhiladelphia === false ? 'no' : '')
  }

  function cancelEdit() {
    setEditingId('')
    setEditName('')
    setEditPhiladelphia('')
    setEditEntrata('')
    setEditActive(true)
    setSavingEdit(false)
  }

  async function saveEdit(row) {
    if (!editName.trim()) {
      alert('Community name is required.')
      return
    }
    if (complianceSetupEnabled && !editPhiladelphia) return alert('Please confirm whether this community is located in the City of Philadelphia.')
    setSavingEdit(true)
    try {
      const patch = {
        communityName: editName.trim(),
        isActive: !!editActive,
      }
      if (complianceSetupEnabled) patch.isCityOfPhiladelphia = editPhiladelphia === 'yes'
      const ent = editEntrata.trim()
      patch.entrataCommunityId = ent === '' ? null : (isNaN(Number(ent)) ? ent : Number(ent))

      await updateDoc(doc(db, 'communities', row.id), patch)
      // local update
      setRows(prev => prev.map(r => (r.id === row.id ? { ...r, ...patch } : r)))
      cancelEdit()
    } catch (e) {
      console.error('saveEdit failed', e)
      alert(e?.message || 'Failed to save changes')
      setSavingEdit(false)
    }
  }

  function openCreate() {
    setCreating(true)
    setNewCode('')
    setNewPhiladelphia('')
    setNewName('')
    setNewEntrata('')
    setNewActive(true)
  }
  function cancelCreate() {
    setCreating(false)
    setCreatingBusy(false)
    setNewCode('')
    setNewPhiladelphia('')
    setNewName('')
    setNewEntrata('')
    setNewActive(true)
  }
  async function createCommunity() {
    const code = newCode.trim()
    const name = newName.trim()
    if (!code) return alert('Code is required.')
    if (!name) return alert('Community name is required.')
    if (complianceSetupEnabled && !newPhiladelphia) return alert('Please confirm whether this community is located in the City of Philadelphia.')
    setCreatingBusy(true)
    try {
      const payload = {
        code,
        communityName: name,
        entrataCommunityId: newEntrata.trim() === '' ? null :
          (isNaN(Number(newEntrata.trim())) ? newEntrata.trim() : Number(newEntrata.trim())),
        isActive: !!newActive,
        market: null,
        region: null,
      }
      if (complianceSetupEnabled) payload.isCityOfPhiladelphia = newPhiladelphia === 'yes'
      const ref = await addDoc(collection(db, 'communities'), payload)
      // local insert
      setRows(prev => [...prev, { id: ref.id, ...payload }])
      cancelCreate()
    } catch (e) {
      console.error('createCommunity failed', e)
      alert(e?.message || 'Failed to create community')
      setCreatingBusy(false)
    }
  }

  // filtering + sorting
  const needle = q.trim().toLowerCase()
  const filtered = rows.filter(r => {
    if (onlyActive && r.isActive === false) return false
    if (!needle) return true
    return [
      r.code,
      r.communityName,
      r.market,
      r.region,
      r.entrataCommunityId && String(r.entrataCommunityId),
    ]
      .filter(Boolean)
      .some(v => String(v).toLowerCase().includes(needle))
  })
  const sorted = [...filtered].sort((a, b) =>
    String(a.code || '').localeCompare(String(b.code || ''))
  )

  return (
    <div>
         <h2
  style={{
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginTop: 14,
    marginBottom: 12,
  }}
>
  <span>Communities</span>
</h2>
      <AdminBar
        title=""
        items={[
          { to: '/admin/users', icon: '👥', title: 'Users', subtitle: 'Manage people & roles' },
          { to: '/admin/communities', icon: '🏢', title: 'Communities', subtitle: 'Properties & aliases', active: true },
          { to: '/admin/groups', icon: '🧩', title: 'Groups', subtitle: 'Access groups & memberships' },
          { to: '/admin/system', icon: '⚙️', title: 'System Config', subtitle: 'Facility types, limits, etc.' },
        ]}
      />

      {/* Search + New / Active toggle */}
      <div className="card" style={{ padding: 16, marginBottom: 12 }}>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
          <input
            aria-label="Search communities"
            placeholder="Search Name/Code/Region/Market…"
            value={q}
            onChange={e => setQ(e.target.value)}
            style={{ flex: 1, minWidth: 240 }}
          />
          <label style={{ display:'inline-flex', alignItems:'center', gap:6 }}>
            <input
              type="checkbox"
              checked={!!onlyActive}
              onChange={e => setOnlyActive(e.target.checked)}
            />
            Show active only
          </label>
          {!creating ? (
            <button onClick={openCreate} data-tooltip="Create a new community">+ New Community</button>
          ) : (
            <button onClick={cancelCreate} data-tooltip="Close">Cancel</button>
          )}
        </div>

        {/* Community onboarding */}
        {creating && (
          <div className="community-create">
            <div className="community-create-heading"><h3>New community</h3><p className="muted">Enter the community details and confirm its location.</p></div>
            <div>
              <label htmlFor="new-community-code">Code</label>
              <input id="new-community-code" value={newCode} onChange={e => setNewCode(e.target.value)} placeholder="e.g., POCGS" />
            </div>
            <div>
              <label htmlFor="new-community-name">Community name</label>
              <input id="new-community-name" value={newName} onChange={e => setNewName(e.target.value)} placeholder="e.g., Port O Call - Gift Shop" />
            </div>
            <div>
              <label htmlFor="new-community-entrata">Entrata ID</label>
              <input id="new-community-entrata" value={newEntrata} onChange={e => setNewEntrata(e.target.value)} placeholder="e.g., 100047959" />
            </div>
            {complianceSetupEnabled && <div className="community-create-location">
              <label htmlFor="new-philadelphia">Is this community located in the City of Philadelphia?</label>
              <select id="new-philadelphia" value={newPhiladelphia} onChange={e => setNewPhiladelphia(e.target.value)} required>
                <option value="">Select Yes or No</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
              <p className="muted" style={{ fontSize: 12, margin: '6px 0 0' }}>Yes makes this community available in Compliance to users with access to it.</p>
            </div>}
            <div className="community-create-footer">
              <label style={{ display:'inline-flex', alignItems:'center', gap:6 }}>
                <input type="checkbox" checked={newActive} onChange={e => setNewActive(e.target.checked)} />
                Active
              </label>
              <button className="btn primary" onClick={createCommunity} disabled={creatingBusy}>
                {creatingBusy ? 'Creating…' : 'Create community'}
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Table */}
      <div className="card" style={complianceSetupEnabled ? { overflowX: 'auto' } : undefined}>
        <div className="responsive-table-scroll" tabIndex={0} role="region" aria-label="Scrollable table"><table className="table community-admin-table" style={{ tableLayout: 'fixed', width: '100%', ...(complianceSetupEnabled ? { minWidth: 1040 } : {}) }}>
          <thead>
            <tr>
              <th style={{ width: '10rem' }}>Code</th>
              <th style={complianceSetupEnabled ? {} : { width: '40%' }}>Community</th>
              <th style={{ width: '10rem' }}>Entrata ID</th>
              {complianceSetupEnabled && <th style={{ width: '11rem', whiteSpace: 'normal', textOverflow: 'clip', lineHeight: 1.35 }}>City of<br />Philadelphia</th>}
              <th style={{ width: '6rem', textAlign: 'center' }}>Active</th>
              <th style={{ width: '14rem', textAlign: 'center' }}>Actions</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr><td colSpan={complianceSetupEnabled ? 6 : 5} className="muted">Loading…</td></tr>
            ) : error ? (
              <tr><td colSpan={complianceSetupEnabled ? 6 : 5} style={{ color: '#b00' }}>{error}</td></tr>
            ) : sorted.length === 0 ? (
              <tr><td colSpan={complianceSetupEnabled ? 6 : 5} className="muted">No communities found.</td></tr>
            ) : (
              sorted.map(row => {
                const isEditing = editingId === row.id
                return (
                  <tr key={row.id}>
                    <td>{row.code || '—'}</td>

                    <td>
                      {isEditing ? (
                        <input
                          value={editName}
                          onChange={e => setEditName(e.target.value)}
                          placeholder="Community name"
                          style={{ width:'100%' }}
                        />
                      ) : (
                        <div><span className="community-cell-value">{row.communityName || '—'}</span></div>
                      )}
                    </td>

                    <td>
                      {isEditing ? (
                        <input
                          value={editEntrata}
                          onChange={e => setEditEntrata(e.target.value)}
                          placeholder="Entrata ID"
                          style={{ width:'100%' }}
                        />
                      ) : (
                        <span className="community-cell-value">{showEntrata(row.entrataCommunityId)}</span>
                      )}
                    </td>

                    {complianceSetupEnabled && <td>
                      {isEditing ? (
                        <select aria-label={`Is ${row.communityName || row.code} located in the City of Philadelphia?`} value={editPhiladelphia} onChange={e => setEditPhiladelphia(e.target.value)} required>
                          <option value="">Not confirmed</option>
                          <option value="yes">Yes</option>
                          <option value="no">No</option>
                        </select>
                      ) : <span className="community-cell-value">{row.isCityOfPhiladelphia === true ? 'Yes' : row.isCityOfPhiladelphia === false ? 'No' : <span className="muted">Not confirmed</span>}</span>}
                    </td>}

                    <td style={{ textAlign:'center' }}>
                      {isEditing ? (
                        <label className="community-active-value">
                          <input
                            type="checkbox"
                            checked={!!editActive}
                            onChange={e => setEditActive(e.target.checked)}
                          />
                          Yes
                        </label>
                      ) : (
                        <span className="community-active-value"><span className="community-checkbox-space" aria-hidden="true" />{row.isActive ? 'Yes' : 'No'}</span>
                      )}
                    </td>

                    <td style={{ textAlign:'center' }}>
                      <div className="community-row-actions">
                        {isEditing ? (
                          <>
                            <button className="btn primary" onClick={() => saveEdit(row)} disabled={savingEdit}>
                              {savingEdit ? 'Saving…' : 'Save'}
                            </button>
                            <button className="btn" onClick={cancelEdit}>Cancel</button>
                          </>
                        ) : (
                          <>
                            <button className="btn" onClick={() => beginEdit(row)}>Edit</button>
                            {row.isActive ? (
                              <button className="btn danger" onClick={() => setActive(row, false)}>Deactivate</button>
                            ) : (
                              <button className="btn" onClick={() => setActive(row, true)}>Reactivate</button>
                            )}
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                )
              })
            )}
          </tbody>
        </table></div>
      </div>
    </div>
  )
}